import { useMemo } from "react";
import { useActiveTask } from "@/sdk";
import { userCache } from "@/shared-utils";

export function usePilots(): { pilots: string[] } {
    const activeTask = useActiveTask();

    const pilots = useMemo(() => {
        return [...userCache.pilots];
        // oxlint-disable-next-line exhaustive-deps
    }, [activeTask]);

    return { pilots };
}
